module.exports = __webpack_public_path__ + "static/img/banner_6.e713406.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/banner_6.png
// module id = /Id1
// module chunks = 1